import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=5ad4aac3&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=ts&"
export * from "./RegisterForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=5ad4aac3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4aac3",
  null
  
)

export default component.exports